
const { ccclass, property } = cc._decorator;
import Utility from "../../../../utility/utility";
import LanguageManager from "../../../../manager/language_manager";
import Q2TableViewBase from "./q2_table_view_base";
import Q2TableSeatView from "./q2_table_seat_view";
import AppData from "../../../public/const/app_data";
import MatchWaitStartView from "../../../public/module/match_wait_start/match_wait_start_view";

@ccclass
export default class Q2TableView extends Q2TableViewBase {

    isMatchingView: boolean = false

    @property(cc.Animation)
    animationBtns: cc.Animation = null

    @property(cc.Button)    
    buttonRaise: cc.Button = null

    @property(cc.Button)
    buttonMoreCard: cc.Button = null

    @property(cc.Button)
    buttonStorage: cc.Button = null

    @property(cc.Button)
    buttonDiscard: cc.Button = null

    @property(cc.Button)
    buttonAttach: cc.Button = null

    @property(cc.Button)
    buttonSortCards: cc.Button = null

    @property(cc.Button)
    buttonShowQ2: cc.Button = null

    @property(cc.Button)
    buttonQuickHu: cc.Button = null

    @property(cc.Button)
    buttonConfirm: cc.Button = null

    @property(cc.Button)
    buttonCancel: cc.Button = null

    @property(cc.Button)
    buttonHint: cc.Button = null

    @property(cc.Node)
    nodeMoreBtn: cc.Node = null

    @property(cc.Label)
    labelRecordLabel: cc.Label = null

    @property(cc.Label)
    labelBubbleTips: cc.Label = null

    @property(cc.Node)
    nodeBubble: cc.Node = null

    @property(MatchWaitStartView)
    matchWaitStartView: MatchWaitStartView = null

    protected m_bubble_schedule_id: number = -1

    onLoad(){
        super.onLoad()
    }

    resetView(){
        if(this.isMatchingView){
            return
        }
        super.resetView()
           
        this.showRaiseBtn(false)
        this.showMoreCardBtn(false)
        this.showAttachBtn(false)
        this.showStorageBtn(false)
        this.showDiscardBtn(false)
        this.showMoreBtn(true)
        this.showShowQ2Btn(false)
        this.showQuickHuBtn(false)
        this.showSortCardsBtn(false)
        this.showConfirmBtn(false)
        this.showCancelBtn(false)
        this.showRecordLabel(false)
        this.showHintBtn(false)
    }

    resetSeatAll(i: number){
        super.resetSeatAll(i)
        this.showSeatIntrustedTag(i, false)

    }

    protected _setBtnGrayAndDisable(btn: cc.Button, gray: boolean){
        Utility.setNodeGray(btn.node, gray)
        btn.enabled = !gray
    }

    

    showSeatIntrustedTag(localPos: number, show: boolean){
        let seatView = this.getSeatViewByPos<Q2TableSeatView>(localPos)
        seatView.showIntrustedTag(show)
    }

    showRaiseBtn(show: boolean, disable?: boolean, isGray?: boolean){
        this.buttonRaise.node.active = !!show
        this.buttonRaise.interactable = !disable
        Utility.setNodeGray(this.buttonRaise.node, isGray)
    }

    showMoreCardBtn(show: boolean, disable?: boolean, isGray?: boolean){
        this.buttonMoreCard.node.active = !!show
        this.buttonMoreCard.enabled = !disable
        Utility.setNodeGray(this.buttonMoreCard.node, isGray)
    }

    showAttachBtn(show: boolean, disable?: boolean, isGray?: boolean){
        this.buttonAttach.node.active = !!show
        this.buttonAttach.enabled = !disable
        Utility.setNodeGray(this.buttonAttach.node, isGray)
    }
    

    showStorageBtn(show: boolean, isGray?: boolean, disable?: boolean){
        this.buttonStorage.node.active = !!show
        this.buttonStorage.enabled = !disable
        Utility.setNodeGray(this.buttonStorage.node, isGray)
    }

    showDiscardBtn(show: boolean, disable?: boolean, isGray?: boolean){
        this.buttonDiscard.node.active = !!show
        this.buttonDiscard.interactable = !disable
        Utility.setNodeGray(this.buttonDiscard.node, isGray)
    }

    showSortCardsBtn(show: boolean, disable?: boolean){
        this.buttonSortCards.node.active = !!show
        this.buttonSortCards.enabled = !disable        
    }

    showShowQ2Btn(show: boolean, disable?: boolean, isGray?: boolean){
        this.buttonShowQ2.node.active = !!show
        this.buttonShowQ2.enabled = !disable
        Utility.setNodeGray(this.buttonShowQ2.node, isGray)
    }

    showQuickHuBtn(show: boolean, disable?: boolean, isGray?: boolean){
        this.buttonQuickHu.node.active = !!show
        this.buttonQuickHu.enabled = !disable
        Utility.setNodeGray(this.buttonQuickHu.node, isGray)
    }

    showMoreBtn(show: boolean){
        this.nodeMoreBtn.active = !!show
    }

    showConfirmBtn(show: boolean, disable?: boolean, isGray?: boolean){
        this.buttonConfirm.node.active = !!show
        this.buttonConfirm.enabled = !disable
        Utility.setNodeGray(this.buttonConfirm.node, isGray)
    }

    showCancelBtn(show: boolean){
        this.buttonCancel.node.active = !!show
    }

    showHintBtn(show: boolean){
        this.buttonHint.node.active = !!AppData.testMode && show     
    }

    playBtnsFadeAnim(show: boolean, onFinish?: Function){
        let self = this
        // let node = self.nodeBtnRoot
        // let fadeFrom = show? 0: 255
        // let fadeTo = show? 255: 0
        // let fromScale = show? 0.7: 1
        // let toScale = show? 1: 0.7
        // let duration = 0.3
        // self.playFadeAnim(node, fadeFrom, fadeTo, duration, 0)
        // node.scale = fromScale
        // self.playNodeAnim(node, node.position, toScale, 0, duration, 0, onFinish, cc.easeBackOut())        
        self.playBtnsAnim(self.animationBtns, show, onFinish)
    }


    protected playBtnsAnim(anim: cc.Animation, show: boolean, onFinish?: Function){
        anim.node.active == !!show
        onFinish && onFinish()

        // let clipName = show? 'anim_anniutanchu': 'anim_anniuxiaoshi'
        // anim.unscheduleAllCallbacks()
        // anim.play(clipName)
        // let duration = show? 0.23: 0.12
        // anim.scheduleOnce(function(){
        //     onFinish && onFinish()
        // }, duration)
    }

    playBtnClickAnim(node: cc.Node){
        let anim = node.getComponent(cc.Animation)
        if(anim){
            anim.play()
        }
    }

    showRecordLabel(show: boolean, recordNo?: string){
        this.labelRecordLabel.node.active = !!show
        if(show){
            this.labelRecordLabel.string = LanguageManager.t("record_number", true) + ':' + recordNo
        }
    }
    
    showBtnTips(show: boolean, text?: string, worldPos?: cc.Vec2){
        this.nodeBubble.active = !!show
        if(this.m_bubble_schedule_id > 0){
            this.cancelSchedule(this.m_bubble_schedule_id)
            this.m_bubble_schedule_id = 0
        }
        if(show){            
            this.labelBubbleTips.string = text
            let pos = this.nodeBubble.parent.convertToNodeSpaceAR(worldPos)
            pos.x += 100
            pos.y += 50
            this.nodeBubble.position = pos
            this.m_bubble_schedule_id = this.doScheduleOnce(()=>{
                this.nodeBubble.active = false
            }, 2)
        }
    }

    showMatchPanel(show: boolean, state: number, leftSecs?: number){
        this.matchWaitStartView.showPanel(show, state, leftSecs)
    }
}
